//import {axiosClient} from '../../main'
import Vue from 'vue'
//import axios from '../../http/axios/index.js'

export default {
  addCoupon ({ commit }, coupon) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.post('/coupons/add/', coupon)
        .then((response) => {
          commit('ADD_COUPON', Object.assign(response.data.data[0]))
          resolve(response)     
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchCoupons ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/coupons/all')
        .then((response) => {
          commit('SET_COUPON', response.data.data.coupons)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCoupon ({ dispatch }, coupon) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.put(`/coupons/update/${coupon.id}`, coupon)
        .then((response) => {
          //commit('UPDATE_PRODUCT', response.data.data.products)
          dispatch('fetchCoupons')
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeCoupon ({ commit }, couponId) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.delete(`/coupons/remove/${couponId}`)
        .then((response) => {
          commit('REMOVE_COUPON', couponId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchProductsInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/coupons/product/info')
        .then((response) => {
          commit('SET_PRODUCTINFO', response.data.data.products)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchUsersInfo ({ commit }) {
    return new Promise((resolve, reject) => {
      Vue.prototype.$http.get('/coupons/user/info')
        .then((response) => {
          commit('SET_USERINFO', response.data.data.users)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  }
}
